<template>
    <form>
        <md-field v-if="showName" >
          <label>{{ $t("common.account.description") }}</label>
          <md-input
            v-model="form.tag"
            data-vv-name="tag"
            type="text"
            @input="changeInfo"
          ></md-input>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('mainAccountIban') }]">
          <label>{{ $t("common.iban") }}</label>
          <md-input
            v-model="form.mainAccountIban"
            data-vv-name="mainAccountIban"
            @input="changeInfo"
            type="text"
            required
            v-validate="modelValidations.mainAccountIban"
          ></md-input>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('mainAccountBic') }]">
          <label>{{ $t("common.bic") }}</label>
          <md-input
            v-model="form.mainAccountBic"
            @input="changeInfo"
            data-vv-name="mainAccountBic"
            type="text"
            required
            v-validate="modelValidations.mainAccountBic"
          ></md-input>
        </md-field>
        <currency-select
          :value="form.currency"
          :disabled="currencyDisable"
          :isError='!form.currency&&touched'
          v-on:input="selectCurrency"
          :required="true"
        ></currency-select>
    </form>
</template>
<script>
import CurrencySelect from "@/components/templates/select/CurrencySelect.vue";

export default {
  props: {
    showName: { type: Boolean, default: true },
    info: { type: [Object, String], default: "" },
    currencyDisable: { type: Boolean, default: false }
  },
  components: {
    CurrencySelect
  },
  data() {
    return {
      modelValidations: {
        tag: {
          required: true
        },
         mainAccountIban: {
          required: true
        },
         mainAccountBic: {
          required: true
        }
      },
      form: {
        mainAccountIban: "",
        tag: "",
        mainAccountBic: "",
        currency: ""
      },
      touched:false
    };
  },
  mounted() {
    this.form = { ...this.form, ...this.info };
  },
  methods: {
    changeInfo() {
      this.$emit("changeInfo", this.form);
    },
    selectCurrency(data) {
      this.form.currency=data
      this.$emit("changeInfo", this.form);
    }
  },
  watch: {
    info() {
      this.form = { ...this.form, ...this.info };
    }
  }
};
</script>